module.exports = __webpack_public_path__ + "scripts/qbdv2_img5.png?0d63e4d5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qbdv2_img5.png
// module id = 893
// module chunks = 1